/**
 * 导航服务组件
 */

import { useState } from 'react';
import {
    BellOutlined,
    HomeOutlined,
    DashboardOutlined,
    SkinOutlined,
    FullscreenOutlined,
    FullscreenExitOutlined,
} from '@ant-design/icons';
import {
    Badge,
    Button,
    Space,
} from 'antd';
import CNF from '../incs/Config';

const XNavService = (props) => {
    const [themeNum, setThemeNum] = useState(0);
    return <Space>
        <Badge
            count={props.msgCount ? props.msgCoun : 0}
            overflowCount={10}
            offset={[0, 5]}
        >
            <Button title='消息' style={{ padding: '0 5px' }} color='primary' variant='link' icon={<BellOutlined />}></Button>
        </Badge>
        <Button title='主界面' style={{ padding: '0 5px' }} color='primary' variant='link' href={CNF.homeUrl} rel='noopener noreferrer' ><HomeOutlined /></Button>
        <Button title='控制台' style={{ padding: '0 5px' }} color='primary' variant='link' href='/' rel='noopener noreferrer' ><DashboardOutlined /></Button>
        <Button title='紧凑的' style={{ padding: '0 5px' }} color='primary' variant='link' onClick={() => {
            // 是否紧凑
            props.setIsCompact(!props.isCompact);
        }} >{
                props.isCompact ? <FullscreenOutlined /> : <FullscreenExitOutlined />
            }
        </Button>
        <Button title='主题皮肤' style={{ padding: '0 5px' }} color='primary' variant='link' onClick={() => {
            // 切换皮肤
            let num = themeNum >= CNF.themeColors.length - 1 ? 0 : themeNum + 1;
            setThemeNum(num);
            global.THEMECOLOR = CNF.themeColors[num];
            props.setThemeColor(CNF.themeColors[num]);
        }} ><SkinOutlined />
        </Button>
    </Space >
}

export default XNavService;